// import Text from './text'
// import videoSrcList from './videoSrcList'
// import imageSrc from './imageSrc'
// import imageSrcList from './imageSrcList'
// import Url from './url'
// import musicSrc from './musicSrc'
import attrQkImage from './attrQkImage'
import attrQkText from './attrQkText'
import attrQkVideo from './attrQkVideo'
import attrQkImageCarousel from './attrQkImageCarousel'
import attrQkIframe from './attrQkIframe'
import attrQkMarquee from './attrQkMarquee'
import attrQkBgMusic from './attrQkBgMusic'

export default {
	//[Text.name]: Text,
	//[videoSrcList.name]: videoSrcList,
	//[imageSrc.name]: imageSrc,
	//[Url.name]: Url,
	//[musicSrc.name]: musicSrc,
	//[imageSrcList.name]: imageSrcList,
    [attrQkImage.name]: attrQkImage,
    [attrQkText.name]: attrQkText,
    [attrQkVideo.name]: attrQkVideo,
    [attrQkImageCarousel.name]: attrQkImageCarousel,
    [attrQkIframe.name]: attrQkIframe,
    [attrQkMarquee.name]: attrQkMarquee,
    [attrQkBgMusic.name]: attrQkBgMusic
}
